import type { JiraProject } from '../../types';

export const isJiraProject = (entity: any): entity is JiraProject =>
	entity.__typename === 'JiraProject';

export const getJiraProjectLink = (project: JiraProject): string | null => project?.webUrl ?? null;
